import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

export default function SkeletonLoaderTable() {
  return (
    <div style={{ margin: '16px' }}>
      <Skeleton variant="rect" animation="wave" height={50} />
      <Skeleton variant="text" animation="wave" />
      <Skeleton variant="rect" animation="wave" height={50} />
      <Skeleton variant="text" animation="wave" />
      <Skeleton variant="rect" animation="wave" height={50} />
      <Skeleton variant="text" animation="wave" />
      <Skeleton variant="rect" animation="wave" height={50} />
      <Skeleton variant="text" animation="wave" />
      <Skeleton variant="rect" animation="wave" height={50} />
      <Skeleton variant="text" animation="wave" />
      <Skeleton variant="rect" animation="wave" height={50} />
      <Skeleton variant="text" animation="wave" />
    </div>
  );
}
